/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Hero_Solo_BodyInputs */

const en_portal_hero_solo_body = /** @type {(inputs: Portal_Hero_Solo_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A plan for every day, a training log and a diet from a photo. No appointments needed.`)
};

const pl_portal_hero_solo_body = /** @type {(inputs: Portal_Hero_Solo_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan na każdy dzień, dziennik i dieta ze zdjęcia. Bez umawiania się z nikim.`)
};

/**
* | output |
* | --- |
* | "A plan for every day, a training log and a diet from a photo. No appointments needed." |
*
* @param {Portal_Hero_Solo_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_hero_solo_body = /** @type {((inputs?: Portal_Hero_Solo_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Hero_Solo_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_hero_solo_body(inputs)
	return en_portal_hero_solo_body(inputs)
});